import TicketResponseActions from './TicketResponseActions';

export default TicketResponseActions;
export { TicketResponseActions };
